
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mathmagic/media",
      function () {
        return require("private-next-pages/mathmagic/media.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mathmagic/media"])
      });
    }
  